module.exports = __webpack_public_path__ + "static/media/is.ba30d1eb.svg";